/**
 * Store Locator - Google Maps Integration
 * Audi-style store finder with search and filtering
 */

// Google Maps Dark Theme Style
var mapDarkStyle = [
  { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#1a3646" }] },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "administrative.country",
    elementType: "geometry.stroke",
    stylers: [{ color: "#4b6878" }]
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "administrative.province",
    elementType: "geometry.stroke",
    stylers: [{ color: "#4b6878" }]
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.stroke",
    stylers: [{ color: "#334e87" }]
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#023e58" }]
  },
  {
    featureType: "poi",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#304a7d" }]
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#98a5be" }]
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#1d2c4d" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#2c6675" }]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [{ color: "#255763" }]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#b0d5ce" }]
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#023e58" }]
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "off" }]
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#0e1626" }]
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#4e6d70" }]
  }
];

function StoreLocator(config) {
  this.config = config;
  this.stores = config.stores || [];
  this.map = null;
  this.markers = [];
  this.activeMarker = null;
  this.activeStore = null;
  this.userLocation = null;
  this.searchRadius = 50;
  this.filteredStores = this.stores.slice();
  this.autocomplete = null;
  this.elements = {};
  
  this.init();
}

StoreLocator.prototype.init = function() {
  this.cacheElements();
  this.bindEvents();
  this.initMap();
  this.renderStoreList(this.stores);
  this.updateStoreCount(this.stores.length);
};

StoreLocator.prototype.cacheElements = function() {
  this.elements = {
    map: document.getElementById('storeMap'),
    searchInput: document.getElementById('storeSearchInput'),
    searchClear: document.getElementById('searchClear'),
    useLocationBtn: document.getElementById('useLocationBtn'),
    radiusSelect: document.getElementById('radiusSelect'),
    storeList: document.getElementById('storeList'),
    storeCount: document.getElementById('storeCount'),
    radiusText: document.getElementById('radiusText'),
    resultsInfo: document.getElementById('resultsInfo'),
    searchPanel: document.getElementById('searchPanel'),
    detailPanel: document.getElementById('detailPanel'),
    detailContent: document.getElementById('detailContent'),
    backToResults: document.getElementById('backToResults'),
    loading: document.getElementById('storeListLoading'),
    empty: document.getElementById('storeListEmpty')
  };
};

StoreLocator.prototype.bindEvents = function() {
  var self = this;
  
  if (this.elements.searchInput) {
    var searchTimeout;
    this.elements.searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function() {
        self.handleSearch();
      }, 300);
    });
    
    this.elements.searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        self.handleSearch();
      }
    });
  }
  
  if (this.elements.searchClear) {
    this.elements.searchClear.addEventListener('click', function() {
      self.clearSearch();
    });
  }
  
  if (this.elements.useLocationBtn) {
    this.elements.useLocationBtn.addEventListener('click', function() {
      self.getUserLocation();
    });
  }
  
  if (this.elements.radiusSelect) {
    this.elements.radiusSelect.addEventListener('change', function(e) {
      self.searchRadius = parseInt(e.target.value);
      if (self.userLocation) {
        self.filterByDistance(self.userLocation);
      }
    });
  }
  
  if (this.elements.backToResults) {
    this.elements.backToResults.addEventListener('click', function() {
      self.showSearchPanel();
    });
  }
};

StoreLocator.prototype.initMap = function() {
  var self = this;
  
  if (!this.elements.map) {
    console.error('Store Locator: Map container not found');
    return;
  }

  if (typeof google === 'undefined' || !google.maps) {
    console.error('Store Locator: Google Maps not loaded');
    return;
  }

  var mapOptions = {
    center: this.config.defaultCenter,
    zoom: this.config.defaultZoom,
    styles: mapDarkStyle,
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER
    },
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    gestureHandling: 'greedy'
  };
  
  this.map = new google.maps.Map(this.elements.map, mapOptions);
  
  this.addMarkers();
  this.initAutocomplete();
  
  if (this.elements.loading) {
    this.elements.loading.style.display = 'none';
  }

  console.log('Store Locator: Map initialized with ' + this.stores.length + ' stores');
};

StoreLocator.prototype.initAutocomplete = function() {
  var self = this;
  
  if (!google.maps.places || !this.elements.searchInput) return;
  
  this.autocomplete = new google.maps.places.Autocomplete(
    this.elements.searchInput,
    {
      types: ['(regions)'],
      componentRestrictions: { country: 'us' }
    }
  );
  
  this.autocomplete.addListener('place_changed', function() {
    var place = self.autocomplete.getPlace();
    if (place.geometry) {
      var location = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      self.userLocation = location;
      self.map.setCenter(location);
      self.map.setZoom(10);
      self.filterByDistance(location);
    }
  });
};

StoreLocator.prototype.createMarkerIcon = function(color, isActive) {
  var size = isActive ? 44 : 36;
  var fillColor = isActive ? '#00d4ff' : '#1a1a1a';
  var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 40 40">' +
    '<circle cx="20" cy="20" r="18" fill="' + fillColor + '" stroke="' + color + '" stroke-width="2"/>' +
    '<circle cx="20" cy="20" r="8" fill="' + color + '"/>' +
    '</svg>';
  return {
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
    scaledSize: new google.maps.Size(size, size),
    anchor: new google.maps.Point(size / 2, size / 2)
  };
};

StoreLocator.prototype.addMarkers = function() {
  var self = this;
  
  this.stores.forEach(function(store) {
    if (!store.lat || !store.lng) return;
    
    var marker = new google.maps.Marker({
      position: { lat: parseFloat(store.lat), lng: parseFloat(store.lng) },
      map: self.map,
      icon: self.createMarkerIcon(self.config.markerColor, false),
      title: store.name
    });
    
    marker.storeId = store.id;
    
    marker.addListener('click', function() {
      self.selectStore(store, marker);
    });
    
    marker.addListener('mouseover', function() {
      if (self.activeMarker !== marker) {
        marker.setIcon(self.createMarkerIcon(self.config.markerActiveColor, false));
      }
    });
    
    marker.addListener('mouseout', function() {
      if (self.activeMarker !== marker) {
        marker.setIcon(self.createMarkerIcon(self.config.markerColor, false));
      }
    });
    
    self.markers.push(marker);
    store.marker = marker;
  });
};

StoreLocator.prototype.selectStore = function(store, marker) {
  var self = this;
  
  if (this.activeMarker) {
    this.activeMarker.setIcon(this.createMarkerIcon(this.config.markerColor, false));
  }
  
  if (marker) {
    marker.setIcon(this.createMarkerIcon(this.config.markerActiveColor, true));
    this.activeMarker = marker;
  } else if (store.marker) {
    store.marker.setIcon(this.createMarkerIcon(this.config.markerActiveColor, true));
    this.activeMarker = store.marker;
  }
  
  this.activeStore = store;
  
  document.querySelectorAll('.store-locator__item').forEach(function(item) {
    item.classList.remove('is-active');
    if (item.dataset.storeId === store.id) {
      item.classList.add('is-active');
    }
  });
  
  this.map.panTo({ lat: parseFloat(store.lat), lng: parseFloat(store.lng) });
  if (this.map.getZoom() < 12) {
    this.map.setZoom(12);
  }
  
  this.showDetailPanel(store);
};

StoreLocator.prototype.showDetailPanel = function(store) {
  this.elements.searchPanel.style.display = 'none';
  this.elements.detailPanel.style.display = 'flex';
  
  var fullAddress = store.address + '<br>' + store.city + ', ' + store.state + ' ' + store.zip;
  var directionsUrl = store.directions_url || 
    'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(store.address + ', ' + store.city + ', ' + store.state + ' ' + store.zip);
  
  var hoursInfo = this.parseHours(store.hours);
  
  var servicesHtml = '';
  if (store.services && store.services.length > 0) {
    var filteredServices = store.services.filter(function(s) { return s; });
    if (filteredServices.length > 0) {
      servicesHtml = '<div class="store-locator__detail-services">' +
        filteredServices.map(function(service) {
          return '<span class="store-locator__service-tag">' + service + '</span>';
        }).join('') +
        '</div>';
    }
  }
  
  var imageHtml = store.image ? 
    '<img src="' + store.image + '" alt="' + store.name + '" class="store-locator__detail-image">' :
    '<div class="store-locator__detail-image-placeholder">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
        '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z"/>' +
        '<circle cx="12" cy="10" r="3"/>' +
      '</svg>' +
    '</div>';
  
  var phoneHtml = store.phone ? 
    '<div class="store-locator__detail-section">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
        '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>' +
      '</svg>' +
      '<div class="store-locator__detail-section-content">' +
        '<p><a href="tel:' + store.phone.replace(/[^0-9+]/g, '') + '">' + store.phone + '</a></p>' +
      '</div>' +
    '</div>' : '';
  
  var emailHtml = store.email ?
    '<div class="store-locator__detail-section">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
        '<rect width="20" height="16" x="2" y="4" rx="2"/>' +
        '<path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>' +
      '</svg>' +
      '<div class="store-locator__detail-section-content">' +
        '<p><a href="mailto:' + store.email + '">' + store.email + '</a></p>' +
      '</div>' +
    '</div>' : '';
  
  var hoursHtml = store.hours ?
    '<div class="store-locator__detail-section">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
        '<circle cx="12" cy="12" r="10"/>' +
        '<polyline points="12 6 12 12 16 14"/>' +
      '</svg>' +
      '<div class="store-locator__detail-section-content">' +
        hoursInfo.statusHtml +
        '<div class="store-locator__hours-list">' + store.hours + '</div>' +
      '</div>' +
    '</div>' : '';
  
  var websiteBtn = store.website ?
    '<a href="' + store.website + '" target="_blank" rel="noopener" class="store-locator__action-btn store-locator__action-btn--secondary">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
        '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>' +
        '<polyline points="15 3 21 3 21 9"/>' +
        '<line x1="10" x2="21" y1="14" y2="3"/>' +
      '</svg>' +
      'Visit Store Page' +
    '</a>' : '';
  
  this.elements.detailContent.innerHTML = 
    imageHtml +
    '<div class="store-locator__detail-body">' +
      '<h2 class="store-locator__detail-name">' + store.name + '</h2>' +
      servicesHtml +
      '<div class="store-locator__detail-section">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z"/>' +
          '<circle cx="12" cy="10" r="3"/>' +
        '</svg>' +
        '<div class="store-locator__detail-section-content">' +
          '<p>' + fullAddress + '</p>' +
        '</div>' +
      '</div>' +
      phoneHtml +
      emailHtml +
      hoursHtml +
      '<div class="store-locator__detail-actions">' +
        '<a href="' + directionsUrl + '" target="_blank" rel="noopener" class="store-locator__action-btn store-locator__action-btn--primary">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            '<polygon points="3 11 22 2 13 21 11 13 3 11"/>' +
          '</svg>' +
          'Get Directions' +
        '</a>' +
        websiteBtn +
      '</div>' +
    '</div>';
};

StoreLocator.prototype.parseHours = function(hoursString) {
  if (!hoursString) return { statusHtml: '', isOpen: null };
  
  var now = new Date();
  var currentHour = now.getHours();
  var isLikelyOpen = currentHour >= 9 && currentHour < 19;
  
  return {
    statusHtml: '<div class="store-locator__hours-status ' + (isLikelyOpen ? 'is-open' : 'is-closed') + '">' +
      (isLikelyOpen ? 'Open now' : 'Closed') +
    '</div>',
    isOpen: isLikelyOpen
  };
};

StoreLocator.prototype.showSearchPanel = function() {
  this.elements.detailPanel.style.display = 'none';
  this.elements.searchPanel.style.display = 'flex';
  
  if (this.activeMarker) {
    this.activeMarker.setIcon(this.createMarkerIcon(this.config.markerColor, false));
    this.activeMarker = null;
  }
  
  document.querySelectorAll('.store-locator__item').forEach(function(item) {
    item.classList.remove('is-active');
  });
};

StoreLocator.prototype.handleSearch = function() {
  var self = this;
  var query = this.elements.searchInput.value.trim();
  
  if (!query) {
    this.clearSearch();
    return;
  }
  
  var geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address: query + ', USA' }, function(results, status) {
    if (status === 'OK' && results[0]) {
      var location = {
        lat: results[0].geometry.location.lat(),
        lng: results[0].geometry.location.lng()
      };
      self.userLocation = location;
      self.map.setCenter(location);
      self.map.setZoom(8);
      self.filterByDistance(location);
    } else {
      self.filterByText(query);
    }
  });
};

StoreLocator.prototype.filterByDistance = function(center) {
  var self = this;
  
  var storesWithDistance = this.stores.map(function(store) {
    var distance = self.calculateDistance(
      center.lat, center.lng,
      parseFloat(store.lat), parseFloat(store.lng)
    );
    var newStore = {};
    for (var key in store) {
      newStore[key] = store[key];
    }
    newStore.distance = distance;
    return newStore;
  });
  
  this.filteredStores = storesWithDistance
    .filter(function(store) { return store.distance <= self.searchRadius; })
    .sort(function(a, b) { return a.distance - b.distance; });
  
  this.renderStoreList(this.filteredStores);
  this.updateStoreCount(this.filteredStores.length);
  this.updateMarkersVisibility();
  
  if (this.elements.radiusText) {
    this.elements.radiusText.textContent = 'within';
  }
  
  if (this.filteredStores.length > 0) {
    this.fitBoundsToStores(this.filteredStores);
  }
};

StoreLocator.prototype.filterByText = function(query) {
  var lowerQuery = query.toLowerCase();
  
  this.filteredStores = this.stores.filter(function(store) {
    return (store.name && store.name.toLowerCase().indexOf(lowerQuery) !== -1) ||
           (store.city && store.city.toLowerCase().indexOf(lowerQuery) !== -1) ||
           (store.state && store.state.toLowerCase().indexOf(lowerQuery) !== -1) ||
           (store.zip && store.zip.indexOf(query) !== -1);
  });
  
  this.renderStoreList(this.filteredStores);
  this.updateStoreCount(this.filteredStores.length);
  this.updateMarkersVisibility();
  
  if (this.elements.radiusText) {
    this.elements.radiusText.textContent = 'matching';
  }
  
  if (this.filteredStores.length > 0) {
    this.fitBoundsToStores(this.filteredStores);
  }
};

StoreLocator.prototype.clearSearch = function() {
  this.elements.searchInput.value = '';
  this.userLocation = null;
  this.filteredStores = this.stores.slice();
  this.renderStoreList(this.stores);
  this.updateStoreCount(this.stores.length);
  this.updateMarkersVisibility();
  
  if (this.elements.radiusText) {
    this.elements.radiusText.textContent = 'within';
  }
  
  this.map.setCenter(this.config.defaultCenter);
  this.map.setZoom(this.config.defaultZoom);
};

StoreLocator.prototype.getUserLocation = function() {
  var self = this;
  
  if (!navigator.geolocation) {
    alert('Geolocation is not supported by your browser');
    return;
  }
  
  this.elements.useLocationBtn.disabled = true;
  this.elements.useLocationBtn.innerHTML = 
    '<div class="store-locator__spinner" style="width: 18px; height: 18px;"></div>' +
    '<span>Getting location...</span>';
  
  navigator.geolocation.getCurrentPosition(
    function(position) {
      var location = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      self.userLocation = location;
      self.map.setCenter(location);
      self.map.setZoom(10);
      self.filterByDistance(location);
      self.resetLocationButton();
    },
    function(err) {
      console.error('Geolocation error:', err);
      alert('Unable to get your location. Please try searching manually.');
      self.resetLocationButton();
    },
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
  );
};

StoreLocator.prototype.resetLocationButton = function() {
  this.elements.useLocationBtn.disabled = false;
  this.elements.useLocationBtn.innerHTML = 
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<circle cx="12" cy="12" r="3"/>' +
      '<path d="M12 2v3m0 14v3M2 12h3m14 0h3"/>' +
    '</svg>' +
    '<span>Use my current location</span>';
};

StoreLocator.prototype.calculateDistance = function(lat1, lon1, lat2, lon2) {
  var R = 3959;
  var dLat = this.toRad(lat2 - lat1);
  var dLon = this.toRad(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) *
          Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

StoreLocator.prototype.toRad = function(deg) {
  return deg * (Math.PI / 180);
};

StoreLocator.prototype.renderStoreList = function(stores) {
  var self = this;
  
  if (stores.length === 0) {
    this.elements.storeList.innerHTML = '';
    if (this.elements.empty) {
      this.elements.empty.style.display = 'flex';
    }
    return;
  }
  
  if (this.elements.empty) {
    this.elements.empty.style.display = 'none';
  }
  
  var html = stores.map(function(store) {
    var distanceText = store.distance !== undefined ? 
      store.distance.toFixed(1) + ' mi' : '';
    
    return '<div class="store-locator__item" data-store-id="' + store.id + '">' +
      '<div class="store-locator__item-header">' +
        '<h3 class="store-locator__item-name">' + store.name + '</h3>' +
        (distanceText ? '<span class="store-locator__item-distance">' + distanceText + '</span>' : '') +
      '</div>' +
      '<p class="store-locator__item-address">' + store.address + '<br>' + store.city + ', ' + store.state + ' ' + store.zip + '</p>' +
    '</div>';
  }).join('');
  
  this.elements.storeList.innerHTML = html;
  
  this.elements.storeList.querySelectorAll('.store-locator__item').forEach(function(item) {
    item.addEventListener('click', function() {
      var storeId = item.dataset.storeId;
      var store = null;
      for (var i = 0; i < self.stores.length; i++) {
        if (self.stores[i].id === storeId) {
          store = self.stores[i];
          break;
        }
      }
      if (store) {
        self.selectStore(store);
      }
    });
  });
};

StoreLocator.prototype.updateStoreCount = function(count) {
  if (this.elements.storeCount) {
    this.elements.storeCount.textContent = count;
  }
};

StoreLocator.prototype.updateMarkersVisibility = function() {
  var self = this;
  var filteredIds = this.filteredStores.map(function(s) { return s.id; });
  
  this.markers.forEach(function(marker) {
    var isVisible = filteredIds.indexOf(marker.storeId) !== -1;
    marker.setVisible(isVisible);
  });
};

StoreLocator.prototype.fitBoundsToStores = function(stores) {
  var self = this;
  
  if (stores.length === 0) return;
  
  var bounds = new google.maps.LatLngBounds();
  stores.forEach(function(store) {
    if (store.lat && store.lng) {
      bounds.extend({ lat: parseFloat(store.lat), lng: parseFloat(store.lng) });
    }
  });
  
  this.map.fitBounds(bounds, { padding: 50 });
  
  var listener = google.maps.event.addListener(this.map, 'idle', function() {
    if (self.map.getZoom() > 14) {
      self.map.setZoom(14);
    }
    google.maps.event.removeListener(listener);
  });
};

// Initialize when Google Maps is loaded
function initStoreLocator() {
  console.log('initStoreLocator called');
  
  if (!window.storeLocatorConfig) {
    console.error('Store Locator: Config not found');
    return;
  }
  
  if (typeof google === 'undefined' || !google.maps) {
    console.error('Store Locator: Google Maps not available');
    return;
  }
  
  window.storeLocatorInstance = new StoreLocator(window.storeLocatorConfig);
}

window.initStoreLocator = initStoreLocator;